module.exports = __webpack_public_path__ + "static/stretchconfblog-5fb1e5ef07e3fff821997d0b0ad282d2.jpeg";